import { theme } from '@coinbase/cdp-react';

export const defaultFonts = {
  sans: theme['font-family-sans'],
  mono: theme['font-family-mono'],
  body: theme['font-family-body'],
  interactive: theme['font-family-interactive'],
} as const;
